import React, { useState, useEffect, memo } from "react";
import "./ScrollToTop.css";

function ScrollToTop() {
  const [showScroll, setShowScroll] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowScroll(window.scrollY > 400);
    };
    
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };

  return (
    <>
      {showScroll && (
        <div className="scroll__to__top__container">
          <button 
            className="scroll__to__top" 
            onClick={scrollToTop}
            role="button" 
            tabIndex="0" 
            aria-label="Scroll to top"
          >
            <span className="scroll__icon" aria-hidden="true">↑</span>
            <div className="scroll__glow" aria-hidden="true"></div>
          </button>
        </div>
      )}
    </>
  );
}

export default memo(ScrollToTop);
